import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var PuffLoader = function PuffLoader(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 44 44' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22, 22)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    r: "20",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "o1",
    attributeName: "opacity",
    from: "1",
    to: "0",
    dur: "1.8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "o1.begin",
    dur: "1.8s",
    type: "scale",
    from: "0.1 0.1",
    to: "1 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    r: "20",
    opacity: "0"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "o2",
    attributeName: "opacity",
    begin: "o1.begin + 0.9s",
    from: "1",
    to: "0",
    dur: "1.8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "o2.begin",
    dur: "1.8s",
    type: "scale",
    from: "0.1 0.1",
    to: "1 1",
    repeatCount: "indefinite"
  }))));
};

PuffLoader.displayName = 'PuffLoader';
export default PuffLoader;